import React from 'react';
import { Link } from 'react-router';
import { Col, Row } from 'react-bootstrap';

import './ButtonChoose.css';

export default class ButtonChoose extends React.Component {

    renderButtonRight() {
        var btn = this.props.buttons[1];

        return (
            <div className="btn-group btn-choose-group">
                <Link to={btn.to} className={"btn btn-choose-text "+ btn.className}>
                    {btn.text}
                </Link>
                <Link to={btn.to} className={"btn btn-choose-glyph "+ btn.className}>
                    <span className="glyphicon glyphicon-menu-right" />
                </Link>
           </div>
        );
    }

    renderButtonLeft() {
        var btn = this.props.buttons[0];

        return (
            <div className="btn-group btn-choose-group">
                <Link to={btn.to} className={"btn btn-choose-glyph "+ btn.className}>
                    <span className="glyphicon glyphicon-menu-left" />
                </Link>
                <Link to={btn.to} className={"btn btn-choose-text "+ btn.className}>
                    {btn.text}
                </Link>
           </div>
        );
    }

    render() {
        return (
            <Row className="btn-choose-wrapper">
                <Col md={12} className="text-center">
                    {this.renderButtonLeft()}
                    {this.renderButtonRight()}
                </Col>
            </Row>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ButtonChoose.js